import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import "./App.css";
import { AuthProvider } from "./lib/auth";
import { SiteProvider } from "./lib/site";
import { useSite } from "./lib/site";
import SmoothScroll from "./components/SmoothScroll";
import ErrorBoundary from "./components/ErrorBoundary";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import QuoteBand from "./components/QuoteBand";
import About from "./pages/About";
import Articles from "./pages/Articles";
import ArticleDetail from "./pages/ArticleDetail";
import Books from "./pages/Books";
import BookDetail from "./pages/BookDetail";
import Consultation from "./pages/Consultation";
import Contact from "./pages/Contact";
import NewsletterPage from "./pages/NewsletterPage";
import InfoPage from "./pages/InfoPage";
import NotFound from "./pages/NotFound";
import AdminApp from "./admin/AdminApp";

function PublicShell({ children }) {
  const { settings } = useSite();
  return (
    <>
      <Header />
      <main>{children}</main>
      <QuoteBand />
      <Footer settings={settings} />
    </>
  );
}

function AdminShell() {
  const location = useLocation();
  return <AdminApp key={location.pathname} />;
}

function RoutedApp() {
  return (
    <>
      <SmoothScroll />
      <Routes>
        <Route path="/" element={<PublicShell><Home /></PublicShell>} />
        <Route path="/tentang" element={<PublicShell><About /></PublicShell>} />
        <Route path="/tulisan" element={<PublicShell><Articles /></PublicShell>} />
        <Route path="/tulisan/:slug" element={<PublicShell><ArticleDetail /></PublicShell>} />
        <Route path="/buku-karya" element={<PublicShell><Books /></PublicShell>} />
        <Route path="/buku-karya/:slug" element={<PublicShell><BookDetail /></PublicShell>} />
        <Route path="/konsultasi" element={<PublicShell><Consultation /></PublicShell>} />
        <Route path="/kontak" element={<PublicShell><Contact /></PublicShell>} />
        <Route path="/newsletter" element={<PublicShell><NewsletterPage /></PublicShell>} />
        <Route path="/privasi" element={<PublicShell><InfoPage pageKey="privacy" /></PublicShell>} />
        <Route path="/ketentuan" element={<PublicShell><InfoPage pageKey="terms" /></PublicShell>} />
        <Route path="/newsletter/konfirmasi" element={<PublicShell><NewsletterPage confirmMode /></PublicShell>} />
        <Route path="*" element={<PublicShell><NotFound /></PublicShell>} />
        <Route path="/admin/*" element={<AdminShell />} />
      </Routes>
      <div className="washi" aria-hidden="true" />
    </>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
        <AuthProvider>
          <SiteProvider>
            <BrowserRouter>
              <RoutedApp />
            </BrowserRouter>
          </SiteProvider>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
